// src/js/store/index.js
import { createStore, applyMiddleware, compose } from 'redux'

import createRootReducer from './rootReducer'
import createSagaMiddleware from 'redux-saga'
import rootSaga from 'sagas'

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  createRootReducer(), // root reducer with router state
  composeEnhancers(applyMiddleware(sagaMiddleware))
)

export default store

sagaMiddleware.run(rootSaga)
